import { CancellationState } from 'lib/graphql';

const getStageSuffix = (stage: CancellationState, error?: Error) => {
  switch (true) {
    case !!error:
    case stage === 'FAILED':
    case stage === 'BLOCKED':
    case stage === 'INVALID':
      return '/error';
    case stage === 'ACCEPTED':
      return '/confirmed';
    case stage === 'ACCEPTING':
      return '/submitting';
    case stage === 'QUOTED':
      return '/review';
    default:
      return '';
  }
};

export default getStageSuffix;
